"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoImageComponent = exports.SpotShowImageComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var PopupImage_1 = require("./PopupImage");
var SpotShowImageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SpotShowImageComponent, _super);
    function SpotShowImageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.spot-cascade';
        return _this;
    }
    SpotShowImageComponent.prototype.OnInit = function () {
        this.el.forEach(function (element) {
            var _a;
            var isDisableImagePopup = ((_a = app_1.AttrService.data(element, 'disable-image-popup')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true' ? true : false;
            var image = element.querySelector('img');
            !isDisableImagePopup && image.classList.add('clickable');
            image.addEventListener('click', function (event) {
                var isDesktop = (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.LGScreen);
                if (!isDesktop || isDisableImagePopup) {
                    return;
                }
                var mediaItem = {
                    altText: event.target['alt'],
                    imageUrl: event.target['src'],
                    hasBorder: false,
                    caption: '',
                    videoUrl: '',
                    disableImagePopup: isDisableImagePopup,
                };
                var popupImageContainer = element.querySelector('.spot-cascade__popup-image-container');
                (0, PopupImage_1.renderPopupImage)(mediaItem, popupImageContainer);
            });
        });
    };
    return SpotShowImageComponent;
}(app_1.Component));
exports.SpotShowImageComponent = SpotShowImageComponent;
exports.promoImageComponent = new SpotShowImageComponent();
